import history from '../../routes/history';
import { generatePath } from 'react-router-dom';
import { AppPath, RouterLinkParams } from '../../routes/pages';
import { History } from 'history';

const goToPage = (
  routerPath: AppPath | string,
  params?: RouterLinkParams,
  query?: string
): void => {
  history.push(generatePath(routerPath, params) + (query ? query : '/'));
};

export type GoToPage = (path: string) => (params?: unknown) => void;
export type GoToSinglePage = (params?: unknown) => void;
export const getGoToPage = <T>(hist: History) => (
  path: AppPath | string,
  shopId?: string,
  classeId?: string
) => (params?: T) => {
  params = shopId && classeId ? { shopId, classeId, ...params } : params;
  return hist.push(
    generatePath(path, params as { [x: string]: string | number | boolean })
  );
};

export default goToPage;
